import { c as _c } from "react/compiler-runtime";
import { findFocusables } from '@udemy-v2/design-system-utils';
import { Modal } from '@udemy-v2/react-dialog-components';
import { Loader, TextSkeleton } from '@udemy-v2/react-reveal-components';
import classNames from 'classnames';
import React, { useRef, useState, useImperativeHandle, forwardRef, useEffect } from 'react';
import { Review as ReviewComponent } from '../review/review.react-component';
import { NoReviewsMessage, noReviewsMessage } from '../reviews.react-component';
import { SearchWidget } from '../review/search-widget.react-component';
import { ReviewsContext } from '../types';
import { ReviewSummaryWidget } from '../review/review-summary-widget.react-component';
import styles from './reviews-modal.module.scss';
import { useReviews, ReviewRequestConfig, UserFieldSelection, ReviewResponseFieldSelection, ReviewFieldSelection, ReviewOrdering } from '@/lib/hooks/use-reviews';
import { publishEvent, TrackImpression } from '@udemy-v2/event-tracking';
import { Review } from '@/types/review';
import { RatingsSummaryImpressionEvent, SeeMoreReviewsClickEvent } from '@/features/course-landing-page/events/events';
import { Button } from '@udemy-v2/react-core-components';
import { useI18n } from '@udemy-v2/i18n';
import { ReviewSkeleton } from '../review/review-skeleton.react-component';
interface ReviewsModalContainerProps {
  reviewsRatings?: ReviewsContext;
  frontendTrackingId?: string;
  reviewableObjectId: number;
  reviewableObjectType: string;
  isXsMax: boolean;
  isOpen: boolean;
  renderTitle: () => React.ReactNode;
  onClose: () => void;
  shouldUseTwoColumnLayout?: boolean;
}
export const ReviewsModalContainer = t0 => {
  const $ = _c(36);
  const {
    reviewsRatings,
    frontendTrackingId,
    reviewableObjectId,
    reviewableObjectType,
    isXsMax,
    isOpen,
    renderTitle,
    onClose,
    shouldUseTwoColumnLayout: t1
  } = t0;
  const shouldUseTwoColumnLayout = t1 === undefined ? false : t1;
  const [searchText, setSearchText] = useState("");
  const [selectedRating, setSelectedRating] = useState(undefined);
  let t2;
  if ($[0] !== reviewsRatings?.courseId) {
    t2 = reviewsRatings?.courseId?.toString() ?? "";
    $[0] = reviewsRatings?.courseId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = searchText ? undefined : true;
  const t4 = searchText || undefined;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [ReviewFieldSelection.RATING];
    t6 = [UserFieldSelection.IMAGE, UserFieldSelection.DISPLAY_NAME];
    t7 = [ReviewResponseFieldSelection.CONTENT, ReviewResponseFieldSelection.USER, ReviewResponseFieldSelection.CREATED, ReviewResponseFieldSelection.ID];
    t8 = [ReviewOrdering.REVIEW_SCORE_RANK, ReviewOrdering.CREATED_DESC];
    $[2] = t5;
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
  } else {
    t5 = $[2];
    t6 = $[3];
    t7 = $[4];
    t8 = $[5];
  }
  let t9;
  if ($[6] !== selectedRating || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t9 = {
      courseId: t2,
      pageSize: 12,
      isTextReview: t3,
      searchText: t4,
      rating: selectedRating,
      fields: t5,
      userFields: t6,
      responseFields: t7,
      ordering: t8
    };
    $[6] = selectedRating;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const reviewsConfig = t9;
  const {
    data: reviews,
    isLoading,
    isLoadingMore,
    fetchNext,
    hasMore,
    ratingDistribution,
    averageRating
  } = useReviews(reviewsConfig);
  let t10;
  if ($[11] !== onClose) {
    t10 = () => {
      onClose();
      setSearchText("");
      setSelectedRating(undefined);
    };
    $[11] = onClose;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const handleOnModalClose = t10;
  let t11;
  if ($[13] !== renderTitle) {
    t11 = renderTitle();
    $[13] = renderTitle;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = frontendTrackingId ?? "";
  let t13;
  if ($[15] !== averageRating || $[16] !== fetchNext || $[17] !== hasMore || $[18] !== isLoading || $[19] !== isLoadingMore || $[20] !== isXsMax || $[21] !== ratingDistribution || $[22] !== reviewableObjectId || $[23] !== reviewableObjectType || $[24] !== reviews || $[25] !== searchText || $[26] !== selectedRating || $[27] !== shouldUseTwoColumnLayout || $[28] !== t12) {
    t13 = <ReviewsModalContent reviews={reviews} isLoading={isLoading} isLoadingMore={isLoadingMore} fetchNext={fetchNext} hasMore={hasMore} ratingDistribution={ratingDistribution} averageRating={averageRating} searchText={searchText} setSearchText={setSearchText} selectedRating={selectedRating} setSelectedRating={setSelectedRating} reviewableObjectType={reviewableObjectType} shouldUseTwoColumnLayout={shouldUseTwoColumnLayout} reviewableObjectId={reviewableObjectId} frontendTrackingId={t12} isXsMax={isXsMax} />;
    $[15] = averageRating;
    $[16] = fetchNext;
    $[17] = hasMore;
    $[18] = isLoading;
    $[19] = isLoadingMore;
    $[20] = isXsMax;
    $[21] = ratingDistribution;
    $[22] = reviewableObjectId;
    $[23] = reviewableObjectType;
    $[24] = reviews;
    $[25] = searchText;
    $[26] = selectedRating;
    $[27] = shouldUseTwoColumnLayout;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== handleOnModalClose || $[31] !== isOpen || $[32] !== isXsMax || $[33] !== t11 || $[34] !== t13) {
    t14 = <Modal onClose={handleOnModalClose} className={styles["reviews-modal"]} isOpen={isOpen} fullPage={isXsMax} title={t11}>{t13}</Modal>;
    $[30] = handleOnModalClose;
    $[31] = isOpen;
    $[32] = isXsMax;
    $[33] = t11;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
interface ReviewsModalContentProps {
  reviews: Review[];
  isLoading: boolean;
  isLoadingMore: boolean;
  fetchNext: () => Promise<void>;
  hasMore: boolean;
  ratingDistribution: {
    rating: number;
    count: number;
  }[];
  averageRating: number;
  searchText: string;
  setSearchText: (text: string) => void;
  selectedRating: number | undefined;
  setSelectedRating: (rating: number | undefined) => void;
  reviewableObjectType: string;
  shouldUseTwoColumnLayout: boolean;
  reviewableObjectId: number;
  frontendTrackingId: string;
  isXsMax: boolean;
}
const ReviewsModalContent = t0 => {
  const $ = _c(65);
  const {
    reviews,
    isLoading,
    isLoadingMore,
    fetchNext,
    hasMore,
    frontendTrackingId,
    ratingDistribution,
    averageRating,
    searchText,
    setSearchText,
    selectedRating,
    setSelectedRating,
    reviewableObjectType,
    shouldUseTwoColumnLayout,
    reviewableObjectId,
    isXsMax
  } = t0;
  const {
    gettext
  } = useI18n();
  const reviewsSectionRef = useRef(null);
  const [firstNewReviewIndex, setFirstNewReviewIndex] = useState(null);
  let t1;
  if ($[0] !== ratingDistribution) {
    t1 = ratingDistribution.reduce(_temp, 0);
    $[0] = ratingDistribution;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const totalDistributionCount = t1;
  const prevReviewsLengthRef = React.useRef(reviews.length);
  let t2;
  let t3;
  if ($[2] !== firstNewReviewIndex || $[3] !== reviews.length) {
    t2 = () => {
      if (firstNewReviewIndex !== null && reviews.length > firstNewReviewIndex && reviews.length !== prevReviewsLengthRef.current) {
        prevReviewsLengthRef.current = reviews.length;
        const timeoutId = requestAnimationFrame(() => {
          const focused = reviewsSectionRef.current?.focusFirstNewReview();
          if (focused) {
            setFirstNewReviewIndex(null);
          }
        });
        return () => cancelAnimationFrame(timeoutId);
      }
    };
    t3 = [reviews.length, firstNewReviewIndex];
    $[2] = firstNewReviewIndex;
    $[3] = reviews.length;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (!reviews) {
    let t4;
    if ($[6] !== shouldUseTwoColumnLayout) {
      t4 = <ReviewsModalContentLoadingSkeleton shouldUseTwoColumnLayout={shouldUseTwoColumnLayout} />;
      $[6] = shouldUseTwoColumnLayout;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  let t4;
  if ($[8] !== frontendTrackingId || $[9] !== reviewableObjectId || $[10] !== reviewableObjectType) {
    t4 = () => {
      if (frontendTrackingId) {
        publishEvent(new RatingsSummaryImpressionEvent({
          courseTrackingId: frontendTrackingId,
          reviewableObjectId,
          reviewableObjectType
        }));
      }
    };
    $[8] = frontendTrackingId;
    $[9] = reviewableObjectId;
    $[10] = reviewableObjectType;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const trackRatingsSummaryImpression = t4;
  let t5;
  if ($[12] !== frontendTrackingId || $[13] !== reviewableObjectId || $[14] !== reviewableObjectType) {
    t5 = () => {
      if (frontendTrackingId) {
        publishEvent(new SeeMoreReviewsClickEvent({
          courseTrackingId: frontendTrackingId,
          reviewableObjectId,
          reviewableObjectType
        }));
      }
    };
    $[12] = frontendTrackingId;
    $[13] = reviewableObjectId;
    $[14] = reviewableObjectType;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const trackSeeMoreReviewsClick = t5;
  let t6;
  if ($[16] !== fetchNext || $[17] !== reviews.length || $[18] !== trackSeeMoreReviewsClick) {
    t6 = async () => {
      trackSeeMoreReviewsClick();
      setFirstNewReviewIndex(reviews.length);
      await fetchNext();
    };
    $[16] = fetchNext;
    $[17] = reviews.length;
    $[18] = trackSeeMoreReviewsClick;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const onSeeMoreReviewsClicked = t6;
  let t7;
  if ($[20] !== shouldUseTwoColumnLayout) {
    t7 = classNames(styles["reviews-modal-content"], {
      [styles["reviews-two-column-layout"]]: shouldUseTwoColumnLayout
    });
    $[20] = shouldUseTwoColumnLayout;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== averageRating || $[23] !== ratingDistribution || $[24] !== selectedRating || $[25] !== setSelectedRating || $[26] !== totalDistributionCount) {
    t8 = <div className={styles["ratings-filter-container"]}><ReviewSummaryWidget showAverageRating={false} averageRating={averageRating} ratingDistribution={ratingDistribution} ratingSize="medium" selectedRating={selectedRating} onRatingSelected={setSelectedRating} totalDistributionCount={totalDistributionCount} /></div>;
    $[22] = averageRating;
    $[23] = ratingDistribution;
    $[24] = selectedRating;
    $[25] = setSelectedRating;
    $[26] = totalDistributionCount;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t8 || $[29] !== trackRatingsSummaryImpression) {
    t9 = <TrackImpression trackFunc={trackRatingsSummaryImpression}>{t8}</TrackImpression>;
    $[28] = t8;
    $[29] = trackRatingsSummaryImpression;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  let t11;
  if ($[31] !== setSearchText) {
    t10 = e => setSearchText(e.target.value);
    t11 = () => setSearchText("");
    $[31] = setSearchText;
    $[32] = t10;
    $[33] = t11;
  } else {
    t10 = $[32];
    t11 = $[33];
  }
  let t12;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      className: styles["search-submit-button"]
    };
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== searchText || $[36] !== t10 || $[37] !== t11) {
    t13 = <SearchWidget onSubmit={_temp2} value={searchText} onChange={t10} onClear={t11} size="small" submitButtonProps={t12} />;
    $[35] = searchText;
    $[36] = t10;
    $[37] = t11;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t13 || $[40] !== t9) {
    t14 = <div className={styles["reviews-controls"]}>{t9}{t13}</div>;
    $[39] = t13;
    $[40] = t9;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== firstNewReviewIndex || $[43] !== frontendTrackingId || $[44] !== isLoading || $[45] !== isXsMax || $[46] !== reviewableObjectId || $[47] !== reviewableObjectType || $[48] !== reviews || $[49] !== searchText || $[50] !== selectedRating) {
    t15 = <ReviewsSection ref={reviewsSectionRef} reviews={reviews} isLoading={isLoading} reviewableObjectType={reviewableObjectType} reviewableObjectId={reviewableObjectId} firstNewReviewIndex={firstNewReviewIndex} searchText={searchText} frontendTrackingId={frontendTrackingId} selectedRating={selectedRating} isXsMax={isXsMax} />;
    $[42] = firstNewReviewIndex;
    $[43] = frontendTrackingId;
    $[44] = isLoading;
    $[45] = isXsMax;
    $[46] = reviewableObjectId;
    $[47] = reviewableObjectType;
    $[48] = reviews;
    $[49] = searchText;
    $[50] = selectedRating;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  let t16;
  if ($[52] !== gettext || $[53] !== hasMore || $[54] !== isLoading || $[55] !== isLoadingMore || $[56] !== onSeeMoreReviewsClicked) {
    t16 = !isLoading && hasMore && <Button data-purpose="show-more-review-button" disabled={isLoadingMore} onClick={onSeeMoreReviewsClicked} className={classNames(styles["show-more-reviews-button"], styles["full-width-button"])} udStyle="secondary">{isLoadingMore ? <Loader color="inherit" size="medium" /> : null}{gettext("Show more reviews")}</Button>;
    $[52] = gettext;
    $[53] = hasMore;
    $[54] = isLoading;
    $[55] = isLoadingMore;
    $[56] = onSeeMoreReviewsClicked;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  let t17;
  if ($[58] !== t15 || $[59] !== t16) {
    t17 = <div className={styles["reviews-list-section"]}>{t15}{t16}</div>;
    $[58] = t15;
    $[59] = t16;
    $[60] = t17;
  } else {
    t17 = $[60];
  }
  let t18;
  if ($[61] !== t14 || $[62] !== t17 || $[63] !== t7) {
    t18 = <div className={t7}>{t14}{t17}</div>;
    $[61] = t14;
    $[62] = t17;
    $[63] = t7;
    $[64] = t18;
  } else {
    t18 = $[64];
  }
  return t18;
};
interface ReviewsSectionProps {
  reviews: Review[];
  isLoading: boolean;
  reviewableObjectType: string;
  reviewableObjectId: number;
  firstNewReviewIndex: number | null;
  searchText?: string;
  frontendTrackingId: string;
  selectedRating: number | undefined;
  isXsMax: boolean;
}
type ReviewsSectionRef = {
  focusFirstNewReview: () => boolean;
};
const ReviewsSection = forwardRef<ReviewsSectionRef, ReviewsSectionProps>((t0, ref) => {
  const $ = _c(15);
  const {
    reviews,
    isLoading,
    reviewableObjectType,
    reviewableObjectId,
    firstNewReviewIndex,
    searchText,
    frontendTrackingId,
    selectedRating,
    isXsMax
  } = t0;
  const firstNewReviewRef = useRef(null);
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => ({
      focusFirstNewReview: () => {
        if (firstNewReviewRef.current) {
          const focusableElements = findFocusables(firstNewReviewRef.current);
          if (focusableElements.length > 0) {
            focusableElements[0].focus();
          } else {
            firstNewReviewRef.current.focus();
          }
          return true;
        }
        return false;
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useImperativeHandle(ref, t1);
  if (isLoading) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ReviewsSectionLoadingSkeleton />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== gettext || $[3] !== searchText || $[4] !== selectedRating) {
    t2 = noReviewsMessage({
      rating: selectedRating,
      searchText
    }, gettext);
    $[2] = gettext;
    $[3] = searchText;
    $[4] = selectedRating;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const message = t2;
  let t3;
  if ($[6] !== firstNewReviewIndex || $[7] !== frontendTrackingId || $[8] !== isXsMax || $[9] !== message || $[10] !== reviewableObjectId || $[11] !== reviewableObjectType || $[12] !== reviews || $[13] !== searchText) {
    t3 = <div className={styles["reviews-list-container"]}>{!reviews || reviews.length === 0 ? <NoReviewsMessage message={message} /> : <div className={styles["reviews-list"]}>{reviews.map((review, index) => {
          const reviewRef = index === firstNewReviewIndex ? firstNewReviewRef : null;
          return <div key={review.id} ref={reviewRef}><ReviewComponent review={review} reviewableObjectType={reviewableObjectType} reviewableObjectId={reviewableObjectId} frontendTrackingId={frontendTrackingId} searchedTerm={searchText} className={styles.review} instructorResponseVisibility="visible" isDesktopLayout={!isXsMax} shouldUseInlineShowMore={true} isModal={true} /></div>;
        })}</div>}</div>;
    $[6] = firstNewReviewIndex;
    $[7] = frontendTrackingId;
    $[8] = isXsMax;
    $[9] = message;
    $[10] = reviewableObjectId;
    $[11] = reviewableObjectType;
    $[12] = reviews;
    $[13] = searchText;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
});
ReviewsSection.displayName = 'ReviewsSection';
const ReviewsModalContentLoadingSkeleton = t0 => {
  const $ = _c(6);
  const {
    shouldUseTwoColumnLayout
  } = t0;
  let t1;
  if ($[0] !== shouldUseTwoColumnLayout) {
    t1 = classNames(styles["reviews-modal-content"], {
      [styles["reviews-two-column-layout"]]: shouldUseTwoColumnLayout
    });
    $[0] = shouldUseTwoColumnLayout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles["reviews-controls"]}><TextSkeleton lineCountPerParagraph={5} /></div>;
    t3 = <ReviewsSectionLoadingSkeleton />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
const ReviewsSectionLoadingSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles["reviews-list"]}>{[...Array(4)].map(_temp3)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(acc, curr) {
  return acc + curr.count;
}
function _temp2() {}
function _temp3(el, i) {
  return <div className={styles["reviews-list-item"]} key={i}><ReviewSkeleton /></div>;
}